<template>
  <div>
    <!-- Information obligation table -->
    <div v-if="isGranted([permissions.PROCESS_INFORMATION_OBLIGATION_VIEW, permissions.PROCESS_INFORMATION_OBLIGATION_VIEW_OWN], process)"
         class="card information_obligation"
         qid="information-obligation-section"
         id="update_information_obligation"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="information-obligation-table-title" v-if="!showOnTask">
                {{ $t('processes.information_obligation.title') }}
              </h5>

              <span v-if="!showOnTask">
                <span class="cursor-pointer task-label-open mr-2"
                      v-if="getTask('update_information_obligation')"
                >
                  <UpdateSingleTaskModal
                      :task="getTask('update_information_obligation')"
                      @reloadContent="reloadContent"
                      :editIcon="true"
                  ></UpdateSingleTaskModal>
                </span>
                <span v-if="getGuide('update_information_obligation')">
                  <GuideButton :guide="getGuide('update_information_obligation')"></GuideButton>
                </span>
              </span>
            </div>
            <div class="validation-info" qid="view-tp-validation" v-if="process.information_obligation_validation">
              <span v-if="process.information_obligation_validation && process.information_obligation_validation.validation === 1">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
                {{ $t('system.approved') }}
              </span>
              <span v-if="process.information_obligation_validation && process.information_obligation_validation.validation === 0">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
                {{ $t('system.rejected') }}
              </span>
              <span v-if="process.information_obligation_validation" class="text-muted font-italic">
                {{ $t('system.by') }}
                <span v-if="process.information_obligation_validation.created_by" qid="view-tp-validation-by">
                  {{ process.information_obligation_validation.created_by.name }}
                </span>
              </span>
              <span v-if="process.information_obligation_validation" class="text-muted font-italic">
                {{ $t('system.on') }}
                <span v-if="process.information_obligation_validation.updated_at" qid="view-tp-validation-date">
                  {{ process.information_obligation_validation.updated_at | formatDate }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-sm-6 text-right">
            <ValidationForm
                :object="process"
                type="information_obligation"
                scope="validate_information_obligation"
                :checklist="validationIOOptions"
                @validationModalClose="handleValidationModalClose"
                v-if="!showOnTask && isGranted([permissions.PROCESS_INFORMATION_OBLIGATION_VALIDATE, permissions.PROCESS_INFORMATION_OBLIGATION_VALIDATE_OWN], process)"
            ></ValidationForm>
            <span v-if="isGranted([permissions.PROCESS_INFORMATION_OBLIGATION_CREATE, permissions.PROCESS_INFORMATION_OBLIGATION_CREATE_OWN], process)"
                    class="btn btn-success pl-3 pr-3 cursor-pointer"
                    qid="io-create-button"
                    @click="showCreateIOModal"
            >
              <font-awesome-icon icon="plus"/> {{ $t('processes.information_obligation.create_button') }}
            </span>
          </div>
        </div>

        <table class="table table-responsive-md table-list-secondary">
          <thead>
          <tr>
            <th scope="col">
              {{ $t('processes.information_obligation.table.name') }}
            </th>
            <th scope="col" class="text-center">
              {{ $t('processes.information_obligation.table.attachment') }}
            </th>
            <th scope="col">
              {{ $t('system.last_updated') }}
            </th>
            <th width="130"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="object in ioTableItems">
              <td>
                <span v-if="object.information_obligation"
                   @click="openViewIOModal(object)"
                   qid="io-name-link"
                   class="btn btn-link text-left cursor-pointer"
                >
                  {{ object.information_obligation.name }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="object.information_obligation.media && object.information_obligation.media.length">
                  <font-awesome-icon icon="paperclip"/>
                </span>
              </td>
              <td>
                <span class="text-normal">
                  {{ object.updated_at | formatDate }}
                </span>
              </td>
              <td align="right">

                <span v-if="object.information_obligation"
                      @click="openViewIOModal(object)"
                      qid="io-name-link"
                      class="btn btn-view"
                >
                  <font-awesome-icon icon="eye"/>
                </span>

                <span v-if="isGranted([permissions.PROCESS_INFORMATION_OBLIGATION_DELETE, permissions.PROCESS_INFORMATION_OBLIGATION_DELETE_OWN], process)"
                      class="btn btn-delete"
                      qid="delete-io-modal"
                      @click="showIOConfirmDeleteModal(object)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </td>
            </tr>
            <tr v-if="!ioLoading && !ioTableItems.length" qid="no-results-row" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
        <br>
        <div class="text-center mb-4" v-if="!showOnTask">
          <span class="cursor-pointer"
                @click="ioValidationShow = !ioValidationShow"
                qid="expand-io-description"
          >
            <span class="mr-2">{{ $t('system.view_validation_log') }}</span>
            <font-awesome-icon icon="chevron-down" v-if="!ioValidationShow"/>
            <font-awesome-icon icon="chevron-up" v-if="ioValidationShow"/>
          </span>
        </div>
        <hr class="mb-0" v-show="ioValidationShow && !showOnTask">
        <ValidationList
            :object="process"
            type="information_obligation"
            :reloadList="updateValidationList"
            @validationListUpdated="setValidation"
            v-show="ioValidationShow && !showOnTask"
        ></ValidationList>
      </div>
    </div>


    <!-- Delete Information obligation modal template -->
    <b-modal ref="delete-io" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-lb-title">
          {{ $t('processes.information_obligation.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('processes.information_obligation.delete.description') }}
        <span v-if="itemToDelete.information_obligation">{{ itemToDelete.information_obligation.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('processes.information_obligation.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideIOConfirmDeleteModal"
                  qid="delete-lb-cancel-button"
        >
          {{ $t('processes.information_obligation.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteIO(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-lb-submit-button"
                  v-if="isGranted([permissions.PROCESS_INFORMATION_OBLIGATION_DELETE, permissions.PROCESS_INFORMATION_OBLIGATION_DELETE_OWN], process)"
        >
          {{ $t('processes.information_obligation.delete.submit') }}
        </b-button>
      </div>
    </b-modal>



    <!-- Add new information obligation -->
    <b-modal ref="add-information-obligation" hide-footer @hide="hideCreateIOModal">
      <div class="d-block text-center">
        <h4 qid="add-io-title">
          {{ $t('processes.information_obligation.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-io-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="ioFormSubmit" qid="create-io-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-io-pg-label">
              {{ $t('processes.information_obligation.create.io_label') }}
            </label>
            <multiselect
                v-model="selectedIO"
                :options="ioItems"
                :placeholder="$t('processes.information_obligation.create.io_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadIO"
                track-by="slug"
                qid="create-lb-form-pg"
            ></multiselect>
          </b-form-group>
          <div v-if="selectedIO && selectedIO.description"
               class="text-center mb-3 mt-4"
          >
            <span class="cursor-pointer">
              <span class="mr-2"
                    @click="showIODescription = !showIODescription"
                    qid="expand-io-description"
              >
                {{ $t('processes.information_obligation.view.description_expand') }}
              </span>
              <font-awesome-icon icon="chevron-down" v-if="!showIODescription"/>
              <font-awesome-icon icon="chevron-up" v-if="showIODescription"/>
            </span>
          </div>
          <div v-if="selectedIO && selectedIO.description && showIODescription" class="mb-4 mt-2">
            <span class="text-formatted">
              {{ selectedIO.description }}
            </span>
          </div>
          <b-form-group v-if="selectedIO && selectedIO.media && selectedIO.media.length">
            <label qid="create-tp-attachments-label">
              {{ $t('maintenance.third_parties.create.attachments') }}
            </label>
            <br>
            <p v-for="file in selectedIO.media" :key="file.file_name">
              <span class="mr-3 float-right text-muted cursor-pointer"
                    @click="downloadMedia(file)"
                    qid="download-media"
              >
                <font-awesome-icon icon="cloud-download-alt" />
              </span>
              <a @click="downloadMedia(file)" qid="create-tp-media-item">
                {{ file.file_name }}
              </a>
            </p>

          </b-form-group>
          <b-form-group v-if="selectedIO && selectedIO.links && selectedIO.links.length">
            <label qid="create-tp-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>
            <p v-for="(link, index) in selectedIO.links">
              <a :href="link.url" target="_blank" qid="create-tp-link-item">
                {{ link.name ? link.name : link.url }}
              </a>
            </p>

          </b-form-group>

        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateIOModal"
                    qid="create-io-cancel-button"
          >
            {{ $t('processes.information_obligation.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-io-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('processes.information_obligation.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <InformationObligationViewModal
        :object="selectedInformationObligation"
        :showModal="viewIOModal"
        @closeViewModal="handleCloseViewIOModal"
    ></InformationObligationViewModal>


  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import InformationObligationViewModal from '@/views/Processes/InformationObligationViewModal.vue';
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'InformationObligationTable',
    data: function() {
      return {
        // information obligation
        ioTableItems: [],
        ioLoading: true,
        ioValidationShow: false,
        showIODescription: false,
        ioItems: [],
        selectedIO: [],
        selectedInformationObligation: {},
        viewIOModal: false,
        validationIOOptions: [],

        error: '',
        loadingItems: false,
        selectedDS: [],
        selectedDSSort: '',
        selectedDSDirection: '',
        acValidationShow: false,
        acTableItems: [],
        acLoading: true,
        dsItems: [],
        updateValidationList: false,
        itemToDelete: {},
        itemObject: {},
        reCertificationOptions: [],
        provisioningOptions: [],
        selectedRC: [],
        selectedP: [],
        validationOptions: [],
        validation: {},
        disabledValidationOptions: [],
        showDSDescription: false,
        buttonDisabled: false,
        selectedDataSubject: {},
        viewDataSubjectModal: false,
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      task: {}
    },
    components: {
      Avatar,
      InformationObligationViewModal,
      ValidationList,
      ValidationForm,
      UpdateSingleTaskModal,
      GuideButton
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {

      },
      object: function (value) {
        if (value && value.slug) {
          this.process = value
          this.validationIOOptions = _.cloneDeep(value.information_obligation_validation_options)
          this.loadInformationObligation();
          this.loadTasks('update_information_obligation');
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.process.id && this.$store.state.updatedObject.who_am_i == this.process.who_am_i) {
              this.process = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_information_obligation')
        }
      },
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadInformationObligation()
        this.loadTasks('update_information_obligation');
      },
      setValidation(object) {
        this.process.information_obligation_validation = object
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.process.who_am_i,
              model_id: this.process.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      handleValidationModalClose() {
        this.updateValidationList = true
        this.loadContent()
      },
      openViewIOModal(object) {
        this.selectedInformationObligation = object
        this.viewIOModal = true
      },
      handleCloseViewIOModal () {
        this.loadInformationObligation();
        this.viewIOModal = false;
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Process' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Process',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showCreateIOModal() {
        this.loadIO()
        this.$refs['add-information-obligation'].show()
      },
      hideCreateIOModal() {
        this.selectedIO = [];
        this.error = ''
        this.showIODescription = false;
        this.$refs['add-information-obligation'].hide()
      },
      updateValidation(validation) {
        // Event emmited from validation component, update active validation
        this.process.validation = validation
      },
      showIOConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-io'].show()
      },
      hideIOConfirmDeleteModal() {
        this.itemToDelete = {}
        this.$refs['delete-io'].hide()
      },
      loadContent() {
        let self = this;
        piincHttp.get('processes/' + this.process.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.process = response.data;
        }, function() {});
      },
      confirmDeleteIO(object) {
        let self = this;
        piincHttp.delete('processes/' + this.process.slug + '/information-obligation/' + object.id).then(function() {
          self.hideIOConfirmDeleteModal();
          self.loadInformationObligation();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('processes.information_obligation.delete.success'))
        }, function() {});
      },
      ioFormSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedIO && this.selectedIO.id) {
          formData.append("information_obligation_id", this.selectedIO.id);
        }

        formData.append("process", this.process.slug);

        piincHttp.post('/processes/' + this.process.slug + '/information-obligation', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('processes.information_obligation.create.success'))
          self.hideCreateIOModal();
          self.buttonDisabled = false;
          self.loadInformationObligation();
          self.loadContent();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;

            if (error.data.errors.information_obligation_id) {
              self.error += ' ' + error.data.errors.information_obligation_id[0]
            }
          }
        })
      },
      // Table list
      loadInformationObligation() {
        let self = this;
        piincHttp.get('processes/' + this.process.slug + '/information-obligation', { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.ioTableItems = response.data;
          self.ioLoading = false;
        }, function() {});
      },
      loadIO(query) {
        let self = this;
        piincHttp.get('information-obligations', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.ioItems = response.data.items
          if (self.ioItems && !self.ioItems.length && !query) {
            self.ioItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
    },
    created () {
      this.process = this.object;
      if (this.getClient && this.getClient.slug) {
        this.loadIO();
      }
      // Table items
      if (this.process && this.process.slug) {
        this.validationIOOptions = _.cloneDeep(this.process.information_obligation_validation_options)
        this.loadInformationObligation();
        this.loadTasks('update_information_obligation');
      }

      this.loadGuides('update_information_obligation');

    }
  }
</script>
